import { createContext, useCallback, useContext, useState } from "react";

const InquiryContext = createContext(null);

export const InquiryProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, program: null });

  const openInquiry = useCallback((program) => {
    setState({ open: true, program: program || null });
  }, []);

  const closeInquiry = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  return (
    <InquiryContext.Provider value={{ ...state, openInquiry, closeInquiry }}>
      {children}
    </InquiryContext.Provider>
  );
};

export const useInquiry = () => {
  const ctx = useContext(InquiryContext);
  if (!ctx) {
    return { open: false, program: null, openInquiry: () => {}, closeInquiry: () => {} };
  }
  return ctx;
};

/**
 * Returns a click handler for any program CTA. If the cta_url is the `#inquire`
 * sentinel (or empty), it opens the modal; otherwise it lets the normal anchor
 * navigation happen.
 */
export const isInquiryCTA = (url) => {
  if (!url) return false;
  return url.trim().toLowerCase() === "#inquire";
};
